import React from 'react'
import { useIntl } from 'react-intl'
import { Box } from '@mui/material'

import { FoldingPanel } from '../../../../../ui'
import { useApplicationUserPermitsContext } from '../../../../../pages/applications/contexts'
import { AppTaskTable } from '../../task-table'
import { ApplicationCommenter } from '../../commenter'

export const HistoryTaskPanel = () => {
  const { formatMessage } = useIntl()
  const { commentsOnLog } = useApplicationUserPermitsContext()

  return (
    <FoldingPanel
      isExpanded={false}
      title={formatMessage({ id: 'pages.application.detail.history.task.title' })}
    >
      <Box display="flex" flexDirection="column" style={{ width: '100%' }}>
        {commentsOnLog ? <ApplicationCommenter /> : null}
        <AppTaskTable />
      </Box>
    </FoldingPanel>
  )
}
